
import React, { Component}  from 'react';
// import { Input as BootstrapInput } from 'reactstrap';
import Field  from './Field';
import FormError from './FormError';


export class InputErrorMessage extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = { visible: true };
    this.onDismiss = this.onDismiss.bind(this);
  }
  
  componentWillReceiveProps(nextProps){
    
    if (this.state.visible === true)
      return
    
    const meta = this.props.meta || this.props;
    const nextMeta = nextProps.meta || nextProps;
    
    if (meta.submitting === true && nextMeta.submitting === false)
      this.setState({ visible: true })
  }
  
  onDismiss() {
    this.setState({ visible: false });
  }
  
  render() {
    const { error, touched, submitError, dirtySinceLastSubmit, title } = this.props.meta || this.props;
    const errors = (error || submitError) instanceof Array ? (error || submitError) : [(error || submitError)];
    const hasErrors = ((error && touched) || (!dirtySinceLastSubmit && submitError));
    // console.log(errors, hasErrors)
    if (this.state.visible && hasErrors)
      return (
        <FormError>{title} 
          {errors.map( (msg, i) => (
            <span key={i}>{msg}</span>
          ))}
        </FormError>
      );
    else
      return (null);
  }
}


const InputError = ({title, ...props}) => {
  return (
    <Field {...props}>
      {({ input, meta }) => {
        return <InputErrorMessage {...{title, ...meta}}  />
      }}
    </Field>
  )
}

export default InputError;


// WEBPACK FOOTER //
// ./src/components/form/InputError.js